import { Inbox } from 'lucide-react';

interface TableEmptyStateProps {
  message?: string;
  className?: string;
}

export function TableEmptyState({ message = 'No data found', className = '' }: TableEmptyStateProps) {
  return (
    <tr>
      <td colSpan={100} className="p-0">
        <div className={`flex flex-col items-center justify-center py-16 px-4 text-center ${className}`}>
          <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center mb-4">
            <Inbox className="w-7 h-7 text-muted-foreground" />
          </div>
          <p className="text-muted-foreground font-medium">{message}</p>
        </div>
      </td>
    </tr>
  );
}
